const getLogo = (preTag) => ({
  object: 'block',
  type: `${preTag}_logo`,
  nodes: [
    {
      object: 'block',
      type: `${preTag}_image`,
      data: {
        src: null,
      },
      nodes: [
        {
          object: 'text',
          leaves: [
            {
              text: '',
            },
          ],
        },
      ],
    },
  ],
});

const getName = (preTag) => ({
  object: 'block',
  type: `${preTag}_organization_name`,
  nodes: [
    {
      object: 'text',
      leaves: [
        {
          text: '',
        },
      ],
    },
  ],
});

const getAddress = (preTag) => ({
  object: 'block',
  type: `${preTag}_organization_address`,
  nodes: [
    {
      object: 'text',
      leaves: [
        {
          text: '',
        },
      ],
    },
  ],
});

export default (params) => {
  const { preTag } = params;

  let nodes;

  /**
   * Conditionally define the nodes inside orgnization details
   * as there would be scenario's where one of the organization detail might not be required
   *
   * * NOTE: Define any new node as a get function, if required
   */

  if (
    preTag === 'work_experience' ||
    preTag === 'education' ||
    preTag === 'awards_and_honors' ||
    preTag === 'volunteer_work' ||
    preTag === 'certifications' ||
    preTag === 'projects' ||
    preTag === 'research_experience' ||
    preTag === 'leadership' ||
    preTag === 'associations' ||
    preTag === 'extra_curricular' ||
    preTag === 'courses' ||
    preTag === 'conferences' ||
    preTag === 'references' ||
    preTag === 'test_scores' ||
    preTag === 'patents'
  ) {
    nodes = [getLogo(preTag), getName(preTag), getAddress(preTag)];
  }

  if (preTag === 'skill') {
    nodes = [getName(preTag)];
  }
  return {
    object: 'block',
    type: `${preTag}_organization_details`,
    nodes,
  };
};
